import styled from 'styled-components'
import Left from './Left'
import Right from './Right'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 32px;
  height: 56px;
  box-sizing: border-box;
`

const Footer = ({ product }) => {
  return (
    <Wrapper>
      <Left wine={product?.wine} />
      <Right qrCodeValue={product?.shortUrl ?? document.location.href} />
    </Wrapper>
  )
}

export default Footer
